module.exports = __webpack_public_path__ + "img/human_edit.c77d38dd.svg";